import React, {PureComponent} from 'react';
import * as ReactGA from '../../GA';
import './TruBridge.css';
import TruBridgeSlide from './TruBridgeSlide';
import TruBridgePeople from './TruBridgePeople';
import TruBridgeSizing from './TruBridgeSizing';
import TruBridgeTecnology from './TruBridgeTecnology';
import i18n from '../../locales/i18n';

const MENU = {
    tecnology: {
        title: 'trubridge.tecnology.title',
        description: 'trubridge.tecnology.description',
        bgImage: require('./trubridge-tecnology-bg.jpg'),
        sections: [
            {
                peoples: [
                    {
                        image: require('./Greg.png'),
                        bridge: require('./bridge-high.png'),
                        label: 'trubridge.tecnology.bridge_high',
                    },
                    {
                        image: require('./Aki.png'),
                        bridge: require('./bridge-medium.png'),
                        label: 'trubridge.tecnology.bridge_medium',
                    },
                    {
                        image: require('./Clay.png'),
                        bridge: require('./bridge-narrow.png'),
                        label: 'trubridge.tecnology.bridge_narrow',
                    },
                    {
                        image: require('./Wen.png'),
                        bridge: require('./bridge-shallow.png'),
                        label: 'trubridge.tecnology.bridge_shallow',
                    },
                ],
            },
            {
                image: require('./silvia-ribeiro.png'),
                label1: 'trubridge.tecnology.label_1',
                label2: 'trubridge.tecnology.label_2',
                label3: 'trubridge.tecnology.label_3',
            },
        ],
    },
    sizing: {
        title: 'trubridge.sizing.title',
        bgImage: require('./trubridge-tecnology-bg.jpg'),
        actionLabel: 'trubridge.sizing.action_label',
        resetLabel: 'trubridge.sizing.reset_label',
        error: {
            label1: 'trubridge.sizing.error.label1',
            label2: 'trubridge.sizing.error.label2',
            label3: 'trubridge.sizing.error.label3',
        },
        correct: {
            label1: 'trubridge.sizing.correct.label1',
            label2: 'trubridge.sizing.correct.label2',
            label3: 'trubridge.sizing.correct.label3',
        },
        slides: [
            {
                name: 'trubridge.sizing.aki.name',
                description: 'trubridge.sizing.aki.description',
                btn1: 'trubridge.sizing.aki.label1',
                btn2: 'trubridge.sizing.aki.label2',
                bridge1: require('./bridge-high.png'),
                bridge1Label: '1',
                bridge2: require('./bridge-medium.png'),
                bridge2Label: '2',
                states: [
                    {
                        name: 'neutro',
                        image: require('./aki-neutro.png'),
                    },
                    {
                        name: 'error',
                        image: require('./aki-error.png'),
                        label1: 'trubridge.sizing.error.label1',
                        label2: 'trubridge.sizing.error.label2',
                        label3: 'trubridge.sizing.error.label3',
                    },
                    {
                        name: 'correct',
                        image: require('./aki-correct.png'),
                        label1: 'trubridge.sizing.correct.label1',
                        label2: 'trubridge.sizing.correct.label2',
                        label3: 'trubridge.sizing.correct.label3',
                    },
                ],
            },
            {
                name: 'trubridge.sizing.clay.name',
                description: 'trubridge.sizing.clay.description',
                btn1: 'trubridge.sizing.clay.label1',
                btn2: 'trubridge.sizing.clay.label2',
                bridge1: require('./bridge-medium.png'),
                bridge1Label: '2',
                bridge2: require('./bridge-narrow.png'),
                bridge2Label: '3',
                states: [
                    {
                        name: 'neutro',
                        image: require('./clay-neutro.png'),
                    },
                    {
                        name: 'error',
                        image: require('./clay-error.png'),
                        label1: 'trubridge.sizing.error.label1',
                        label2: 'trubridge.sizing.error.label2',
                        label3: 'trubridge.sizing.error.label3',
                    },
                    {
                        name: 'correct',
                        image: require('./clay-correct.png'),
                        label1: 'trubridge.sizing.correct.label1',
                        label2: 'trubridge.sizing.correct.label2',
                        label3: 'trubridge.sizing.correct.label3',
                    },
                ],
            },
            {
                name: 'trubridge.sizing.wen.name',
                description: 'trubridge.sizing.wen.description',
                btn1: 'trubridge.sizing.wen.label1',
                btn2: 'trubridge.sizing.wen.label2',
                bridge1: require('./bridge-medium.png'),
                bridge1Label: '2',
                bridge2: require('./bridge-shallow.png'),
                bridge2Label: '4',
                states: [
                    {
                        name: 'neutro',
                        image: require('./wen-neutro.png'),
                    },
                    {
                        name: 'error',
                        image: require('./wen-error.png'),
                        label1: 'trubridge.sizing.error.label1',
                        label2: 'trubridge.sizing.error.label2',
                        label3: 'trubridge.sizing.error.label3',
                    },
                    {
                        name: 'correct',
                        image: require('./wen-correct.png'),
                        label1: 'trubridge.sizing.correct.label1',
                        label2: 'trubridge.sizing.correct.label2',
                        label3: 'trubridge.sizing.correct.label3',
                    },
                ],
            },
            {
                name: 'trubridge.sizing.greg.name',
                description: 'trubridge.sizing.greg.description',
                btn1: 'trubridge.sizing.greg.label1',
                btn2: 'trubridge.sizing.greg.label2',
                bridge1: require('./bridge-high.png'),
                bridge1Label: '1',
                bridge2: require('./bridge-medium.png'),
                bridge2Label: '2',
                states: [
                    {
                        name: 'neutro',
                        image: require('./greg-neutro.png'),
                    },
                    {
                        name: 'error',
                        image: require('./greg-error.png'),
                        label1: 'trubridge.sizing.error.label1',
                        label2: 'trubridge.sizing.error.label2',
                        label3: 'trubridge.sizing.error.label3',
                    },
                    {
                        name: 'correct',
                        image: require('./greg-correct.png'),
                        label1: 'trubridge.sizing.correct.label1',
                        label2: 'trubridge.sizing.correct.label2',
                        label3: 'trubridge.sizing.correct.label3',
                    },
                ],
            },
        ],
        sections: [{}],
    },
};

export default class TruBridge extends PureComponent {
    state = {
        type: this.props.match.params.type,
        state: 'tecnology1',
        slide: 0,
        slideState: 0,
    };

    static getDerivedStateFromProps(props, state) {
        if (props.match.params.type !== state.type) {
            return {
                type: props.match.params.type,
                state: 'tecnology1',
                slide: 0,
                slideState: 0,
            };
        }

        return null;
    }

    componentDidMount() {
        ReactGA.pageview(
            `${i18n.language}/Trubridge/${this.state.type}/${
                this.state.type === 'tecnology'
                    ? this.state.state
                    : this.state.slide
            }/${this.state.type === 'sizing' ? this.state.slideState : ''}`
        );
    }
    componentDidUpdate() {
        ReactGA.pageview(
            `${i18n.language}/Trubridge/${this.state.type}/${
                this.state.type === 'tecnology'
                    ? this.state.state
                    : this.state.slide
            }/${this.state.type === 'sizing' ? this.state.slideState : ''}`
        );
    }

    onSwipe = event => {
        if (event.direction === 4) {
            if (this.state.state === 'tecnology2') {
                this.setState({
                    state: 'tecnology1',
                });
            }
        }

        if (event.direction === 2) {
            if (this.state.state === 'tecnology1') {
                this.setState({
                    state: 'tecnology2',
                });
            }
        }
    };

    changeBridge = state => {
        this.setState({slideState: state});
    };

    handleSlide = direction => {
        const activeSlide = this.state.slide;
        if (activeSlide === 0 && direction === 'prev') {
            this.props.history.push('tecnology');
        }
        const slide =
            direction === 'next'
                ? Math.min(this.state.slide + 1, 3)
                : Math.max(this.state.slide - 1, 0);
        this.setState({
            slide: slide,
            slideState: 0,
        });
    };

    render() {
        const type = this.props.match.params.type;
        const history = this.props.history;

        const currentType = MENU[type];
        let style;
        let peoples;
        let content;

        const bullets = Object.keys(currentType.sections).map(
            (singleSection, index) => (
                <div
                    key={singleSection}
                    className={
                        (this.state.state === 'tecnology1' && index === 0) ||
                        (this.state.state === 'tecnology2' && index === 1)
                            ? 'bullet bullet--active'
                            : 'bullet'
                    }
                />
            )
        );

        style = {backgroundImage: `url(${currentType.bgImage})`};

        peoples =
            currentType.sections[0].peoples &&
            currentType.sections[0].peoples.map((people, index) => (
                <TruBridgePeople people={people} key={index} index={index} />
            ));

        if (this.state.type === 'tecnology') {
            content = (
                <TruBridgeTecnology
                    style={style}
                    currentType={currentType}
                    peoples={peoples}
                    bullets={bullets}
                    history={history}
                    swipe={this.onSwipe}
                    state={this.state.state}
                />
            );
        }

        if (this.state.type === 'sizing') {
            let currentSlide = this.state.slide;
            let currentState = this.state.slideState;
            const slide = currentType.slides[currentSlide];
            let slides = (
                <TruBridgeSlide
                    slide={slide}
                    currentType={currentType}
                    currentState={currentState}
                    currentSlide={currentSlide}
                    changeBridge={this.changeBridge}
                />
            );

            content = (
                <TruBridgeSizing
                    style={style}
                    currentType={currentType}
                    currentSlide={currentSlide}
                    changeBridge={this.changeBridge}
                    handleSlide={this.handleSlide}
                    slides={slides}
                />
            );
        }

        return <article className="TruBridge">{content}</article>;
    }
}



// WEBPACK FOOTER //
// ./src/screens/trueBridge/TruBridge.js